module.exports = "/images/no-data-trips.svg?b951b01ce92f4c6905ea76804deaf837";